import { UserApplicationProperties } from './user-application-properties.model';
import { BaseUser } from './base-user.model';
import { Application } from 'app/shared/services/app/application/application.model';
import { StudentGroup } from 'app/shared/services/user/student/student-group.model';

export class AppUser extends BaseUser {
  localRole: UserApplicationProperties;
  company: string = '';

  timeLoggedInSeconds: number;
  isEnrolled: boolean;
  groups: StudentGroup[] = [];
  groupStrings: string = ''; // for on the detail page, where we really don't need the entire group object
  averageExamScore: number;
  // example: { field: "Reason for Taking Course", value: "wants to learn how to read good and do other stuff good too" }
  studentPayload: { field: string, value: string }[] = [];
  exams: { id: number, grade: number, title: string }[] = [];
  age: string = '';
  organization: string = '';

  isLocked: boolean;
  isPending: boolean;
  permissions: any[] = [];

  fullGroupNames: string = '';
  shortGroupNames: string = '';

  constructor(json?: any) {
    super(json || null);
    if (json) {
      this.localRole = new UserApplicationProperties(json.role);
      this.company = json.company;

      this.isEnrolled = json.is_enrolled || false;
      this.timeLoggedInSeconds = json.logged_in_seconds || 0;
      this.averageExamScore = json.avg_exam_score || 0;
      if (json.payload && json.payload.length) this.studentPayload = json.payload;
      if (json.grades && json.grades.length) {
        json.grades.forEach(exam => {
          this.exams.push({
            id: exam.id,
            grade: exam.percent,
            title: exam.title || ''
          });
        });
      };
      if (json.groups) this.groupStrings = json.groups.join(', ');

      if (json.age) this.age = json.age;
      if (json.organization) this.organization = json.organization;

      this.isLocked = json.is_locked || false;
      this.isPending = json.is_new_user || false;

      this.permissions = json.permissions;
    }
  }

  get timeLoggedString(): string {
    if (this.timeLoggedInSeconds < 60) return 'Not Started';

    let hours = Math.floor(this.timeLoggedInSeconds / 3600);
    let minutes = Math.floor((this.timeLoggedInSeconds - (hours * 3600)) / 60);
    let timeString = '';

    timeString += hours < 10 ? '0' + hours : hours;
    timeString += ':';
    timeString += minutes < 10 ? '0' + minutes : minutes;

    return timeString;
  }

  get showAsStudent() {
    return this.isEnrolled ||
           this.averageExamScore > 0 ||
           this.timeLoggedInSeconds > 0 ||
           this.exams.length > 0;
  }

  updateGroupNames() {
    let groupNames = this.groups.map(group => group.title);

    if (groupNames.length > 2) this.shortGroupNames = groupNames.length + ' groups';
    else this.shortGroupNames = groupNames.join(', ');

    this.fullGroupNames = groupNames.join(', ');
  }

  addGroup(group: StudentGroup) {
    if (this.fullGroupNames.indexOf(group.title) === -1) this.groups.push(group);
    this.updateGroupNames();
  }

  removeGroup(group: StudentGroup) {
    let index = this.groups.indexOf(group);
    if (index > -1) this.groups.splice(index, 1);
    this.updateGroupNames();
  }

  toJson() {
    let json: any = {
      id: this.id,
      first_name: this.lastName,
      last_name: this.lastName,
      email: this.email,
      app_role_names: this.roles.map(role => role.toJson()),

      is_enrolled: this.isEnrolled,
      logged_in_seconds: this.timeLoggedInSeconds,
      score: this.averageExamScore,
      payload: this.studentPayload,
      grades: this.exams.map((grade) => {
        return {
          exam: { id: grade.id, title: grade.title },
          percent: grade.grade
        };
      }),
      groups: this.groups.map(group => group.title),
      is_locked: this.isLocked,
      is_new_user: this.isPending
    };
    return json;
  }

  copy() {
    return new AppUser(this.toJson());
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/app-user.model.ts